import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { Overlay } from 'react-overlays'

export class OverlayTrigger extends Component {
  state = {
    show: false,
  }

  static propTypes = {
    trigger: PropTypes.any,
    children: PropTypes.any,
    placement: PropTypes.string,
    container: PropTypes.any,
    component: PropTypes.any,
    rootClose: PropTypes.bool,
    shouldUpdatePosition: PropTypes.bool,
    triggerType: PropTypes.oneOf(['click', 'hover']),
  }

  static defaultProps = {
    triggerType: 'click',
  }

  forceClose() {
    this.setState({ show: false })
  }

  getTargetRect() {
    const targetRect = ReactDOM.findDOMNode(this._trigger).childNodes[0].getBoundingClientRect()
    const container = this.props.container()
    const rect = { width: targetRect.width, height: targetRect.height, top: targetRect.top, left: targetRect.left }

    if (container && container.id !== 'portal') {
      rect.left = targetRect.left - container.getBoundingClientRect().left
      rect.top = targetRect.top - container.getBoundingClientRect().top
    }

    return rect;
  }

  render() {
    const { triggerType } = this.props
    const Comp = this.props.component || 'div'
    return (
      <div className="overlay-trigger">
        <div
          className="overlay-trigger__trigger"
          ref={(r) => this._trigger = r}
          onClick={() => { if (triggerType === 'click') { this.setState({ show: true }) }}}
          onMouseEnter={() => { if (triggerType === 'hover') this.setState({ show: true })}}
          onMouseLeave={() => { if (triggerType === 'hover') this.setState({ show: false })}}
        >
          {this.props.trigger}
        </div>
        <Overlay
            show={!!this.state.show}
            onHide={() => this.setState({ show: false })}
            placement={this.props.placement}
            rootClose={this.props.rootClose}
            container={this.props.container}
            shouldUpdatePosition={this.props.shouldUpdatePosition}
            target={() => ReactDOM.findDOMNode(this._trigger).childNodes[0]}
        >
          <Comp {...this.props} onClick={() => this.setState({ show: false })}>
            {this.renderContent()}
          </Comp>
        </Overlay>
      </div>
    )
  }

  renderContent() {
    return React.Children.map(this.props.children, (child) => child || false)
  }
}
